import {Box} from "@mui/material";

export const FilterBox = ({ label, selectedItems, isShowSelect, onClick }) => {
  const isDefault = selectedItems[0] === '不限';
  const displayText = isDefault
    ? label
    : selectedItems.length === 1 && selectedItems[0] !== '不限'
      ? selectedItems[0]
      : `${label} (${selectedItems.length})`;

  return (
    <Box
      className="flex-1 flex flex-row items-center gap-2 justify-center"
      onClick={onClick}
    >
      <p className={`font-light ${isDefault ? 'text-gray-600' : 'text-purple-800'}`}>
        {displayText}
      </p>
      <i
        className={`fas fa-caret-${isShowSelect ? 'up' : 'down'} text-gray-600`}
        style={{ fontSize: '14px' }}
      />
    </Box>
  );
};
